import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, collection, getDocs, query, where, doc, setDoc,getDoc } from '../firebase';
import { QRCodeCanvas } from 'qrcode.react';

import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { fetchTournaments } from './tournamentsData';
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { tournamentTranslations } from '../i18n/translations';

const PROVINCES_BY_TERRITORY = {
  wallonia: [
    ['Hainaut', 'provinceHainaut'],
    ['Brabant Wallon', 'provinceWalloonBrabant'],
    ['Namur', 'provinceNamur'],
  ],
  flanders: [
    ['Antwerpen', 'provinceAntwerp'],
  ],
};

const TournamentList = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = createTranslator(language, tournamentTranslations);
  const [participantsCounts, setParticipantsCounts] = useState({});
  const [upcomingTournaments, setUpcomingTournaments] = useState([]);
  const [pastTournaments, setPastTournaments] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedTournamentId, setSelectedTournamentId] = useState(null);
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [filter, setFilter] = useState({ territory: 'wallonia', region: 'all', status: 'all' });
  const [winners, setWinners] = useState({});
  const [tournaments, setTournaments] = useState([]);
  const [loadingTournaments, setLoadingTournaments] = useState(true);
  const [tournamentsError, setTournamentsError] = useState('');


  
  useEffect(() => {
    const loadTournaments = async () => {
      try {
        setLoadingTournaments(true);
        setTournamentsError('');
  
        const data = await fetchTournaments();
  
        console.log('✅ DONNÉES REÇUES DANS TOURNAMENTLIST:', data);
        console.log('✅ NOMBRE TOURNOIS:', data.length);
  
        setTournaments(data);
      } catch (error) {
        console.error('❌ Erreur chargement tournament_catalog:', error);
        setTournamentsError('Impossible de charger les tournois.');
      } finally {
        setLoadingTournaments(false);
      }
    };
  
    loadTournaments();
  }, []);

  useEffect(() => {
    console.log('Sorting tournaments into upcoming and past categories...', tournaments.length);
  
    if (!tournaments.length) {
      setUpcomingTournaments([]);
      setPastTournaments([]);
      return;
    }
  
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    const sortedTournaments = tournaments.reduce(
      (acc, tournament) => {
        const tournamentDate = new Date(`${tournament.date}T00:00:00`);
        tournamentDate.setHours(0, 0, 0, 0);
  
        const tournamentDatePlusOne = new Date(tournamentDate);
        tournamentDatePlusOne.setDate(tournamentDatePlusOne.getDate() + 1);
  
        if (tournamentDatePlusOne >= today) {
          acc.upcoming.push(tournament);
        } else {
          const twoWeeksAgo = new Date(today);
          twoWeeksAgo.setDate(today.getDate() - 14);
  
          if (tournamentDatePlusOne >= twoWeeksAgo) {
            acc.past.push(tournament);
          }
        }
  
        return acc;
      },
      { upcoming: [], past: [] }
    );
  
    sortedTournaments.upcoming.sort((a, b) => {
      return new Date(`${a.date}T00:00:00`) - new Date(`${b.date}T00:00:00`);
    });
  
    sortedTournaments.past.sort((a, b) => {
      return new Date(`${b.date}T00:00:00`) - new Date(`${a.date}T00:00:00`);
    });
  
    console.log(`Upcoming Tournaments: ${sortedTournaments.upcoming.length}`);
    console.log(`Past Tournaments: ${sortedTournaments.past.length}`);
  
    setUpcomingTournaments(sortedTournaments.upcoming);
    setPastTournaments(sortedTournaments.past);
  }, [tournaments]);
  
  
// Avant d'utiliser counts
const counts = {}; // Initialisation de l'objet counts
// Avant d'utiliser tournamentIds
const tournamentIds = tournaments.map(tournament => tournament.id.toString());


useEffect(() => {
  const fetchAllParticipantsCounts = async () => {
    try {
      const res = await fetch("https://us-central1-mendyx-adafe.cloudfunctions.net/getAllParticipantsCounts");
      const data = await res.json();

      if (res.ok && data.counts) {
        const parsedCounts = {};
        for (const id in data.counts) {
          parsedCounts[parseInt(id)] = data.counts[id];
        }
        setParticipantsCounts(parsedCounts);
      } else {
        console.error("Erreur serveur ou structure inattendue :", data.error || "Réponse invalide");
      }
    } catch (error) {
      console.error("Erreur de requête globale :", error);
    }
  };

  fetchAllParticipantsCounts();
}, []);

useEffect(() => {
  const fetchWinners = async () => {
    if (!tournaments.length) {
      setWinners({});
      return;
    }

    const map = {};

    const promises = tournaments
      .filter(t => Number(t.id) >= 270)
      .map(async (t) => {
        const ref = doc(db, "winners", t.id.toString());
        const snap = await getDoc(ref);

        return {
          id: t.id,
          data: snap.exists() ? snap.data() : null,
        };
      });

    const results = await Promise.all(promises);

    results.forEach(({ id, data }) => {
      if (data) map[id] = data;
    });

    setWinners(map);
  };

  fetchWinners();
}, [tournaments]);

  const handleRegisterClick = (tournamentId) => {
    console.log(`Navigating to register for tournament ID: ${tournamentId}`);
    navigate(`/register/${tournamentId}`);
  };

  const handlePaymentClick = (tournamentId) => {
    setSelectedTournamentId(tournamentId);
    setShowPaymentModal(true);
  };
  
  const handleCloseModal = () => {
    setShowPaymentModal(false);
    setSelectedTournamentId(null);
  };

  
  

  const handleViewTournamentClick = (tournamentId) => {
    console.log(`Navigating to view tournament ID: ${tournamentId}`);
    navigate(`/tournament/${tournamentId}/view`);
  };

  const handleViewParticipantsClick = async (tournamentId) => {
    console.log(`Fetching participants for tournament ID: ${tournamentId}`);
    
    try {
      const res = await fetch(`https://us-central1-mendyx-adafe.cloudfunctions.net/getTournamentParticipants?tournamentId=${tournamentId}`);
      const data = await res.json();
  
      if (res.ok && data.participants) {
        const participantsList = data.participants
          .map(p => p.teamName || "Équipe sans nom")
          .sort((a, b) => a.localeCompare(b));
  
        setParticipants(participantsList);
        setShowParticipantsModal(true);
      } else {
        console.error("Erreur participants :", data.error || "Réponse inattendue");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
    }
  };
  
  

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const matchesLocationFilter = (tournament) => {
    const territory = tournament.territory || 'wallonia';
    const territoryMatch = territory === filter.territory;
    const provinceMatch = filter.region === 'all' || tournament.region === filter.region;

    return territoryMatch && provinceMatch;
  };

  
  const renderTournamentCard = (tournament) => {
    const isFull = participantsCounts[tournament.id] === tournament.players; // Vérifie si le tournoi est complet
    const isPast = new Date(tournament.date) < new Date(); // Tournoi déjà passé

    return (
        <div key={tournament.id} className="relative p-8 bg-white shadow-lg rounded-3xl border border-gray-200 transform transition hover:scale-105 duration-300 ease-in-out">
            
            {/* Banderole rouge "COMPLET" */}
            {isFull && (
                <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 rounded-bl-2xl text-sm font-bold">
                    COMPLET
                </div>
            )}

{tournament.badge && (
  <div className="absolute top-0 left-0 bg-yellow-400 text-black px-4 py-1 rounded-br-2xl text-xs font-bold shadow-md">
    {tournament.badge}
  </div>
)}

{tournament.badgef && (
  <div className="absolute top-0 left-0 bg-pink-400 text-black px-4 py-1 rounded-br-2xl text-xs font-bold shadow-md">
    {tournament.badgef}
  </div>
)}



            {tournament.picture && (
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-2xl font-semibold text-[#4c2f8e] break-words">
                        {tournament.name}
                    </h3>
                    <img
                        src={tournament.picture}
                        alt={`Logo de ${tournament.name}`}
                        className="w-16 h-16 rounded-full border-2 border-gray-200 shadow object-cover ml-4"
                        loading="lazy"
                    />
                </div>
            )}

{winners[tournament.id] && (
  <div className="relative mb-5 overflow-hidden rounded-2xl border border-[#d8c7a3] bg-gradient-to-br from-[#fffdf8] via-[#f8f3e8] to-[#efe5d0] px-5 py-4 shadow-[0_16px_40px_rgba(54,42,25,0.12)]">
    {/* lignes verticales premium */}
    <div className="absolute left-0 top-0 h-full w-[6px] bg-gradient-to-b from-[#f6e7b4] via-[#c6a15b] to-[#8b6a2f]" />
    <div className="absolute left-[10px] top-0 h-full w-[2px] bg-gradient-to-b from-[#ffffff] via-[#d7d2c8] to-[#9c9588]" />

    {/* reflet discret sans coupure */}
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#c6a15b]/6 pointer-events-none" />
    <div className="absolute -top-16 -right-12 h-36 w-36 rounded-full bg-[#c6a15b]/10 blur-3xl pointer-events-none" />

    <div className="relative z-10 pl-3">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.30em] text-[#8b6a2f]">
            {t('champions')}
          </p>

          <h4 className="mt-1 text-xl font-black text-[#241c12]">
            🏆 {winners[tournament.id].teamName}
          </h4>
        </div>

        <div className="hidden sm:flex items-center rounded-full border border-[#c6a15b]/40 bg-[#fffaf0] px-3 py-1 text-[11px] font-black uppercase tracking-[0.18em] text-[#7a5a22] shadow-sm">
          {t('winner')}
        </div>
      </div>

      <div className="mt-3 h-px w-full bg-gradient-to-r from-[#c6a15b]/70 via-[#d8d0bf] to-transparent" />

      <div className="mt-3 flex flex-wrap gap-2">
        {winners[tournament.id].players?.map((p, i) => (
          <span
            key={i}
            className="rounded-full border border-[#d8c7a3]/70 bg-white/80 px-3 py-1 text-sm font-bold text-[#4a3820] shadow-sm"
          >
            {p.prenom} {p.nom}
          </span>
        ))}
      </div>
    </div>
  </div>
)}

            <p className="text-gray-600 mb-1">{t('teams')} : {tournament.players}</p>
            <p className="text-gray-600 mb-1">{t('location')} : <strong>{tournament.location}</strong></p>
            <p className="text-gray-600 mb-1">{t('date')} : {t('on')} {formatDate(tournament.date)} {tournament.time}</p>
{/* <p className="text-gray-600 mb-1">
    Inscrits : {participantsCounts[tournament.id] || 0}
</p> */}         {/* {tournament.eloMin && tournament.eloMax && (
  <p className="text-gray-600 mb-1">
    Catégorie : {tournament.eloMin} - {tournament.eloMax} points (par équipe)
  </p>
)}  */}


            <div className="mt-4 flex flex-col gap-4 md:flex-row md:gap-4">
            <button
  onClick={() => handleRegisterClick(tournament.id)}
  className={`w-full md:w-auto px-4 py-2 text-sm md:text-base rounded-full transition duration-300 ${
    isFull || tournament.registrationDisabled
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-[#4c2f8e] text-white hover:bg-white hover:text-[#4c2f8e] border hover:border-[#4c2f8e]"
  }`}
  disabled={isFull || tournament.registrationDisabled}
>
  {isFull
    ? t('full')
    : tournament.registrationDisabled
    ? t('registrationClosed')
    : t('register')}
</button>

    <button
      type="button" // AJOUTER CECI POUR ÉVITER LA REDIRECTION

  onClick={() => handleViewTournamentClick(tournament.id)}
  className="w-full md:w-auto px-4 py-2 text-sm md:text-base rounded-full transition duration-300 bg-[#4c2f8e] text-white hover:bg-white hover:text-[#4c2f8e] border hover:border-[#4c2f8e]"
>
  {t('viewTournament')}
</button>


    <button
        onClick={() => handleViewParticipantsClick(tournament.id)}
        className="w-full md:w-auto px-4 py-2 text-sm md:text-base bg-[#4c2f8e] text-white rounded-full hover:bg-white hover:text-[#4c2f8e] border hover:border-[#4c2f8e] transition duration-300"
    >
        {t('viewParticipants')}
    </button>

    {/* Nouveau bouton pour rediriger vers le règlement du tournoi */}
    <button
        onClick={() => window.location.href = '/reglementtournoi'}
        className="w-full md:w-auto px-4 py-2 text-sm md:text-base bg-[#4c2f8e] text-white rounded-full hover:bg-white hover:text-[#4c2f8e] border hover:border-[#4c2f8e] transition duration-300"
    >
        {t('rules')}
    </button>
</div>

        </div>
    );
};

  return (
    <>

<Helmet>
      <title>{t('pageTitle')}</title>
      <meta
        name="description"
        content="Découvrez et inscrivez-vous aux tournois de padel organisés par Padel Mendyx en Belgique. Consultez les tournois à venir et passés."
      />
      <meta name="keywords" content="tournois de padel, compétition padel Belgique, Namur, Charleroi, Brabant Wallon, Padel Mendyx" />
      <meta property="og:title" content="Tournois de Padel en Belgique | Padel Mendyx" />
      <meta property="og:description" content="Découvrez les tournois de padel à Namur, Charleroi, et Brabant Wallon. Rejoignez une compétition avec Padel Mendyx !" />
      <meta property="og:image" content="https://padelmedyx.com/images/tournament-preview.jpg" />
      <meta property="og:url" content="https://padelmedyx.com/tournamentlist" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Tournois de Padel en Belgique | Padel Mendyx" />
      <meta name="twitter:description" content="Rejoignez les meilleurs tournois de padel en Wallonie avec Padel Mendyx." />
      <meta name="twitter:image" content="https://padelmedyx.com/images/tournament-preview.jpg" />
      <link rel="canonical" href="https://padelmedyx.com/tournamentlist" />
      <script type="application/ld+json">
        {JSON.stringify(
          tournaments.map(tournament => ({
            "@context": "https://schema.org",
            "@type": "Event",
            "name": tournament.name,
            "startDate": `${tournament.date}T14:00:00+01:00`,
            "endDate": `${tournament.date}T18:30:00+01:00`,
            "location": {
              "@type": "Place",
              "name": tournament.location.split('|')[0].trim(),
              "address": {
                "@type": "PostalAddress",
                "streetAddress": tournament.location.split('|')[1].trim(),
                "addressCountry": "BE"
              }
            },
            "image": `https://padelmedyx.com/images/${tournament.picture}`,
            "description": `Participez à ${tournament.name} organisé par Padel Mendyx.`,
            "offers": {
              "@type": "Offer",
              "url": `https://padelmedyx.com/register/${tournament.id}`,
              "price": tournament.price,
              "priceCurrency": "EUR",
              "availability": "https://schema.org/InStock"
            }
          }))
        )}
      </script>
    </Helmet>

    <section className="container mx-auto my-24 px-4">
      <div>
        <h2 className="text-3xl font-semibold text-[#4c2f8e] mb-12 text-center">{t('upcoming')}</h2>

        <div className="flex flex-wrap justify-center gap-2.5 mb-4">
          <button
            onClick={() => setFilter((current) => ({ ...current, region: 'all' }))}
            className={`px-3.5 py-1.5 md:px-6 md:py-2 text-xs md:text-sm rounded-full font-medium border transition ${
              filter.region === 'all'
                ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
                : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
            }`}
          >
            {t('all')}
          </button>
          {PROVINCES_BY_TERRITORY[filter.territory].map(([province, labelKey]) => (
            <button
              key={province}
              onClick={() => setFilter((current) => ({ ...current, region: province }))}
              className={`px-3.5 py-1.5 md:px-6 md:py-2 text-xs md:text-sm rounded-full font-medium border transition ${
                filter.region === province
                  ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
                  : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
              }`}
            >
              {t(labelKey)}
            </button>
          ))}
        </div>

{/* Ligne de séparation design */}
<div className="flex justify-center mb-4">
  <div className="w-full max-w-[90%] px-4">
    <div className="border-t-[1px] border-[#4c2f8e] border-dotted opacity-50"></div>
  </div>
</div>

<div className="flex justify-center gap-2.5 mb-12">
  <button
    onClick={() => setFilter((current) => ({ ...current, status: 'all' }))}
    className={`px-3.5 py-1.5 md:px-6 md:py-2 text-xs md:text-sm rounded-full font-medium border transition ${
      filter.status === 'all'
        ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
        : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
    }`}
  >
    {t('all')}
  </button>
  <button
    onClick={() => setFilter((current) => ({ ...current, status: 'available' }))}
    className={`px-3.5 py-1.5 md:px-6 md:py-2 text-xs md:text-sm rounded-full font-medium border transition ${
      filter.status === 'available'
        ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
        : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
    }`}
  >
    {t('available')}
  </button>
  <button
    onClick={() => setFilter((current) => ({ ...current, status: 'full' }))}
    className={`px-3.5 py-1.5 md:px-6 md:py-2 text-xs md:text-sm rounded-full font-medium border transition ${
      filter.status === 'full'
        ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
        : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
    }`}
  >
    {t('fullPlural')}
  </button>
</div>



        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24">
        {upcomingTournaments.length > 0 ? (
 upcomingTournaments
 .filter(t => {
   const territoryMatch = (t.territory || 'wallonia') === filter.territory;
   // Filtrage par région
   const regionMatch = filter.region === 'all' || t.region === filter.region;
   // Filtrage par statut
   const count = participantsCounts[t.id] || 0;
   const statusMatch =
     filter.status === 'all' ||
     (filter.status === 'full' && count >= t.players) ||
     (filter.status === 'available' && count < t.players);
   return territoryMatch && regionMatch && statusMatch;
 })
 .map(renderTournamentCard)


          ) : (
            <p className="text-center text-gray-500">{t('noUpcoming')}</p>
          )}
        </div>
      </div>

      <div className="mt-16">
        <h2 className="text-3xl font-semibold text-[#4c2f8e] mb-12 text-center">{t('past')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24">
          {pastTournaments.filter(matchesLocationFilter).length > 0 ? (
            pastTournaments.filter(matchesLocationFilter).map(renderTournamentCard)
          ) : (
            <p className="text-center text-gray-500">{t('noPast')}</p>
          )}
        </div>
      </div>
      {showPaymentModal && <PaymentModal onClose={handleCloseModal} t={t} />}
      {showParticipantsModal && (
  <ParticipantsModal 
    participants={participants} 
    onClose={() => setShowParticipantsModal(false)}
    t={t}
  />
)}

    </section>
    </>
  );
};

export default TournamentList;

function PaymentModal({ onClose, t }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-red-500 hover:text-red-700 text-xl"
        >
          &times;
        </button>
        <div className="mb-4 text-gray-700">
          <strong>{t('payment')} :</strong> BE65 0019 9907 2996
          <br />
          <strong>{t('price')} :</strong> {t('pricePerPlayer')}
          <br />
          <strong>{t('paymentReference')} :</strong> {t('teamName')}
          <br />
          <br />
          {t('poolsHint')}
          <br />
          <br />
          <strong className="text-center">{t('ready')}</strong>
        </div>
        <div className="flex flex-col items-center">
          <p className="text-center mb-2 text-gray-700">{t('scan')}</p>
          <QRCodeCanvas
            value={`BCD
001
1
SCT
BICDEABCXXX
Padel Mendyx SRL
BE65 0019 9907 2996
EUR40.00`}
            size={150}
            level="M"
          />
        </div>
      </div>
    </div>
  );
}

function ParticipantsModal({ participants, onClose, t }) {
  return (

    

    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-red-500 hover:text-red-700 text-xl"
        >
          &times;
        </button>
        <h2 className="text-2xl font-semibold mb-4 text-center text-[#4c2f8e]">{t('participants')}</h2>
        <table className="w-full border border-[#4c2f8e]" role="table" aria-label={t('registeredTeams')}>
          
          <thead>
            <tr className="bg-[#4c2f8e] text-white">
              <th className="px-4 py-2 border-b-2 border-[#4c2f8e]">{t('teamColumn')}</th>
            </tr>
          </thead>
          <tbody>
            {participants.length > 0 ? (
              participants.map((participant, index) => (
                <tr key={index} className="border-b border-[#4c2f8e]">
                  <td className="px-4 py-2 text-center">{participant}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-4 py-2 text-center text-gray-500" colSpan="1">{t('nobody')}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>

    
  );
}
